export default __webpack_public_path__ + "images/magnifier.v-79e417dfce2a6dd11cd6d25a26c052a8.png";